<template>
  <van-sticky
    :offsetTop="stickOffsetTop"
    :class="{
      'consult-channel-list-filterbar': true,
      'slide-up': animation && scrollDirection === 1
    }"
    :style="
      opened
        ? {
            zIndex: 9
          }
        : {}
    "
    ref="outer"
    @change="isFixed => $emit('filterBarStickyChange', isFixed)"
  >
    <van-popup
      v-model="show"
      :lazy-render="false"
      v-bind="{
        position: 'top',
        style: {
          top: filterModelTop + `px`,
          zIndex: 0
        },
        'overlay-style': {
          top: filterModelTop + `px`,
          zIndex: 0
        },
        class: 'popup'
      }"
      @opened="opened = true"
      @close="opened = false"
      @closed="selectedType = ''"
    >
      <lv2TagsSelects
        class="lv2-tags"
        v-if="options.lv2Tags && selectedType === 'lv2Tags'"
        :list="options.lv2Tags"
        :value="value"
        :top="filterModelTop"
        title="请选择你的困扰（多选）"
        @change="change"
      />
      <selects
        v-show="selectedType === 'tag'"
        :title="pageType === 'activity' ? '' : '服务类别'"
        :list="options.tags"
        :value="value"
        @change="change"
      />
      <!-- title="排序方式" -->
      <selects
        v-show="selectedType === 'sort'"
        :list="options.sorts"
        :size="200"
        :value="value"
        @change="change"
      />
      <treeSelects
        v-if="options.areas"
        v-show="selectedType === 'area' && options.areas[0].list"
        :list="options.areas"
        :value="value"
        @change="change"
      />
      <treeSelectsMore
        v-if="options.areas"
        v-show="selectedType === 'areaWithDistrict' && options.areas[0].list"
        :list="options.areas"
        :value="value"
        :types="['province', 'city', 'district']"
        ref="areaTree"
        :initFun="areaSelectInitFun"
        @change="change"
      />
      <selects
        v-if="
          options.areas && selectedType === 'area' && !options.areas[0].list
        "
        :list="options.areas"
        :size="210"
        :value="value"
        @change="change"
      />
      <selects
        v-if="selectedType === 'price'"
        :list="options.prices"
        :size="210"
        :value="value"
        @change="change"
      />
      <classifySelects
        v-if="selectedType === 'priceMore'"
        :list="[{ list: options.pricesMore, type: 'price' }]"
        :value="value"
        @change="change"
      />
      <selects
        v-if="selectedType === 'preConsult'"
        :list="options.preConsult"
        :size="210"
        :value="value"
        @change="change"
      />
      <selects
        v-if="selectedType === 'gender'"
        :list="options.genders"
        :size="210"
        :value="value"
        @change="change"
      />
      <selects
        v-if="selectedType === 'waytype'"
        :list="options.waytypes"
        :size="210"
        :value="value"
        @change="change"
      />
      <classifySelects
        v-if="options.filters && selectedType === 'filter'"
        :list="options.filters"
        :dates="options.dates"
        :value="value"
        :top="filterModelTop"
        type="filter"
        @change="change"
      />
      <dateSelects
        v-if="options.dates && selectedType === 'date'"
        :value="value"
        title="咨询时间（北京时间，可多选）"
        :list="options.dates"
        @change="change"
      />
    </van-popup>

    <div class="container" ref="container">
      <div class="row">
        <div
          v-for="(item, index) in items"
          :class="{
            col: true,
            selected: item.selected || item.type === selectedType,
            distict: item.type === 'areaWithDistrict'
          }"
          @click="handleitem(item, index)"
          :key="index"
          v-stat="item.stat"
        >
          <span> {{ item.name }} </span>
          <icon
            :name="
              item.type === selectedType && item.selectIcon
                ? item.selectIcon
                : item.defaultIcon
            "
            :class="{
              selected: item.type === selectedType || item.selected
            }"
            v-if="!item.defaultImg"
          />
          <img
            :src="
              item.type === selectedType && item.selectImg
                ? item.selectImg
                : item.defaultImg
            "
            v-else-if="item.defaultImg"
            class="select-icon"
          />
        </div>
      </div>
      <slot />
    </div>

    <div v-if="sortBarType === 'tag' && tags">
      <div
        class="sort-bar-wrap"
        v-if="tags.length"
        :class="{
          'sort-bar-wrap': true,
          'slide-up': scrollDirection === 1 && sortBarSlideWhenScroll
        }"
      >
        <sortBar
          :list="tags"
          :value="value"
          :mask="true"
          :selected="sortBarSelected"
          @change="v => change(v, 'sortBar')"
          @sortBarClick="params => $emit('sortBarClick', params)"
        />
      </div>
    </div>

    <div style="font-size: 12px" v-else-if="showSubSort && options.sorts">
      <sortBar
        :list="options.sorts"
        :value="value"
        @change="change"
        @sortBarClick="params => $emit('sortBarClick', params)"
      />
      <!-- filterModelTop : {{ filterModelTop }} tabContainerHeight:
      {{ tabContainerHeight }} stickOffsetTop: {{ stickOffsetTop }} -->
    </div>
  </van-sticky>
</template>

<script>
import { Popup, Sticky } from 'vant'
// import Popup from 'vant/lib/popup'
// import 'vant/lib/popup/style'
import directionScrollMixin from 'mixins/directionScroll'
import treeSelects from 'app/web/component/consult/listCommon/treeSelects.vue'
import treeSelectsMore from 'app/web/component/consult/listCommon/treeSelectsMore.vue'
import selects from 'app/web/component/consult/listCommon/selects.vue'
import { getScrollTop } from 'app/frontend-lib/tools/utils.js'
import classifySelects from 'app/web/component/consult/listCommon/classifySelects.vue'
import lv2TagsSelects from 'app/web/component/consult/listCommon/lv2TagsSelects.vue'
import sortBar from 'app/web/component/consult/listCommon/sortBar.vue'
import dateSelects from 'app/web/component/consult/listCommon/dateSelects.vue'
import iconArrowUp from 'images/common/icon-arrow-up.png'
import iconArrowDown from 'images/common/icon-arrow-down.png'

export default {
  name: 'filterBar',
  mixins: [directionScrollMixin],
  components: {
    [Sticky.name]: Sticky,
    [Popup.name]: Popup,
    treeSelects,
    selects,
    sortBar,
    classifySelects,
    dateSelects,
    treeSelectsMore,
    lv2TagsSelects
  },
  props: {
    value: {
      type: Object
    },
    stickOffsetTop: {
      type: [Number, String],
      default: 0
    },
    options: {
      type: Object
    },
    filter: {
      type: Array,
      default() {
        return ['tag', 'area', 'price', 'filter']
      }
    },
    animation: {
      type: Boolean,
      default: true
    },
    sortBarType: {
      type: String,
      default: 'sort'
    },
    // 上滑隐藏，下滑出现
    sortBarSlideWhenScroll: {
      type: Boolean,
      default: false
    },
    // 默认选中
    defaultSelect: {
      type: Boolean,
      default: false
    },
    pageType: {
      type: String,
      default: ''
    },
    showSubSort: {
      type: Boolean,
      default: true
    },
    dataStore: {
      type: Object
    }
  },
  data() {
    return {
      inputValue: '',
      visible: true,
      show: false,
      tabContainerHeight: 40,
      selectedType: '',
      opened: false,
      iconArrowUp,
      iconArrowDown,
      sortBarSelected: false
    }
  },

  computed: {
    tags() {
      return this.options.hotTags
    },
    directionScrollMin() {
      return 400
    },
    items() {
      const {
        tag,
        city,
        province,
        price,
        pre_consult,
        gender,
        way_type,
        consult_schedule,
        time,
        district,
        sort,
        child_tag
      } = this.value
      const {
        tags,
        prices,
        preConsult,
        genders,
        waytypes
        // sorts = []
      } = this.options
      const _tag = tags.find(v => tag === v.value)
      // const _sort = sorts.find(v => sort === v.value) || sorts[0]
      const _area = district ? district : city ? city : province
      let _price = price && prices.find(v => price === v.value)
      if (this.filter.includes('priceMore'))
        _price = { value: price, name: '价格' }
      const _pre_consult =
        pre_consult && preConsult.find(v => pre_consult === v.value)
      const _gender = gender && genders.find(v => gender === v.value)
      const _waytype = way_type && waytypes.find(v => way_type === v.value)

      let barData = [
        {
          name: '困扰',
          type: 'lv2Tags',
          selected: child_tag && !this.value['frontendKey-hotKey'],
          stat: '困扰'
        },
        {
          name: _tag
            ? _tag.name
            : this.pageType === 'activity'
            ? '方向'
            : '咨询方向',
          selected: !!tag,
          type: 'tag',
          stat: '分类'
        },
        {
          name: '排序',
          selected: !!sort,
          type: 'sort',
          stat: '分类'
        },
        {
          name: _area ? _area : '地区',
          selected: !!_area,
          type: 'area',
          stat: '地区'
        },
        {
          name: _area ? _area : '城市',
          selected: !!_area,
          type: 'areaWithDistrict',
          stat: '地区'
        },
        {
          name: _price && _price.value ? _price.name : '价格',
          selected: !!(_price && _price.value),
          type: 'price',
          stat: '价格'
        },

        {
          name: _price && _price.value ? _price.name : '价格',
          selected: !!(_price && _price.value),
          type: 'priceMore',
          stat: '价格'
        },

        {
          name: _pre_consult ? _pre_consult.name : '是否预咨询',
          selected: !!(_pre_consult && _pre_consult.value),
          type: 'preConsult'
        },

        {
          name: _gender ? _gender.name : '性别',
          selected: !!(_gender && _gender.value),
          type: 'gender',
          stat: '性别'
        },

        {
          name: _waytype
            ? _waytype.name
            : this.pageType === 'activity'
            ? '方式'
            : '咨询方式',
          selected: !!(_waytype && _waytype.value),
          type: 'waytype',
          stat: '咨询方式'
        },

        {
          name: '筛选',
          type: 'filter',
          stat: '筛选'
        },
        {
          name: '时间',
          selected: !!consult_schedule || !!time,
          type: 'date',
          stat: '时间'
        }
      ].map(v => {
        const { selectIcon, defaultIcon } = v
        if (!selectIcon && !defaultIcon) {
          v.selectImg = this.iconArrowUp
          v.defaultImg = this.iconArrowDown
        }
        return v
      })

      return this.filter.map(v => {
        return barData.find(k => k.type === v)
      })
    },
    filterModelTop() {
      return this.tabContainerHeight + this.stickOffsetTop
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { $el } = this.$refs['container']
      if ($el) {
        this.tabContainerHeight = $el.clientHeight
      }
    })

    this.$watch(
      () => this.show,
      val => {
        this.$emit('selecting', val)
      },
      { immediate: true }
    )
    // this.$watch(() => this.stickOffsetTop, this.$forceUpdate)
    this.sortBarSelected = this.defaultSelect
  },
  methods: {
    areaSelectInitFun() {
      const selectedIndexs = {
        province: 0
      }
      const selections = {
        province: this.options?.areas,
        city: this.options.areas[0]?.list
      }
      return [selectedIndexs, selections]
    },
    stickyBarToTop(to = false) {
      // let { offsetTop } = this.$refs['outer'].$el

      let offsetTop = this.$refs['outer'].$el.getBoundingClientRect().top
      // const offsetTop = this.stickOffsetTop
      const scrollTop = getScrollTop()

      let sleep = 0

      console.log(offsetTop, scrollTop)

      if (offsetTop > 0 || to) {
        // setScrollTop(offsetTop)
        window.scrollTo(0, scrollTop + offsetTop - this.stickOffsetTop)
        sleep = 100
      }

      return this.sleep(sleep)
    },
    async handleitem(item) {
      if (item.type === this.selectedType) {
        this.show = false
        return
      }

      await this.stickyBarToTop()
      this.selectedType = item.type
      this.show = true
      this.$emit('clickItem', item)
    },

    getFilter(options) {
      const { selectedType } = this
      let filter = ''
      if (selectedType === 'filter') {
        let _filer = []
        for (let key in options) {
          if (options[key]) {
            if (key === 'way_type') {
              _filer.push('方式')
            }
            if (key === 'gender') {
              _filer.push('性别')
            }
            if (key === 'pre_consult' || key === 'feature') {
              _filer.push('咨询师特色')
            }
            if (key === 'age') {
              _filer.push('年龄')
            }
            if (key === 'group') {
              _filer.push('群体')
            }
            if (key === 'therapy') {
              _filer.push('流派')
            }
          }
        }
        filter = _filer.join('、')
      } else if (selectedType.includes('lv2Tags')) {
        filter = '困扰'
      } else {
        filter =
          {
            tag: '方向',
            area: '地区',
            price: '价格',
            date: '时间',
            waytype: '方式'
          }[selectedType] || '排序'
      }
      return filter
    },

    async change(v, type) {
      // 清理二级困扰
      const { selectedType } = this
      if (type === 'sortBar') {
        const { options } =
          this.dataStore || this.$store.state.consultListCommon
        for (const key in options) {
          if (key.includes('frontendKey-lv2Tags') && options[key]) v[key] = ''
        }
        let isReset = false
        // 重置标签
        for (const key in v) {
          if (v[key] && this.value[key] === v[key]) {
            v[key] = ''
            isReset = true
          }
        }
        v['frontendKey-hotKey'] = !isReset
        this.sortBarSelected = !isReset
        ;['tag', 'child_tag'].forEach(key => {
          if (v[key] === undefined) {
            v[key] = ''
          }
        })
      } else {
        if (selectedType === 'lv2Tags') {
          v.tag = []
          v.child_tag = []
          const { selectOption } =
            this.dataStore || this.$store.state.consultListCommon
          for (const key in v) {
            if (key.includes('frontendKey-lv2Tags')) {
              const data = v[key]
              const id = key.split(' - ')[1]
              // 选择全部
              if (data.includes('all')) {
                v.tag.push(key.split(' - ')[1])
                v.child_tag.push(
                  ...(selectOption?.lv2_tags[id] || []).map(tag => tag.value)
                )
                continue
              }
              if (data[0]) v.child_tag.push(...data)
            }
          }
          v.tag = v.tag.join(',')
          v.child_tag = v.child_tag.join(',')
          v['frontendKey-hotKey'] = false
          this.sortBarSelected = false
        }
      }

      const filter = this.getFilter(v)
      this.show = false
      this.selectedType = ''
      if (this.sortBarSlideWhenScroll) {
        this.scrollDirection = 0
      }
      // let { offsetTop } = this.$refs['outer'].$el
      // window.scrollTo(0, offsetTop - this.stickOffsetTop)
      await this.stickyBarToTop(true)
      this.$emit('change', v, {
        type: selectedType,
        filter
      })
    },

    areaReset() {
      this.$refs.areaTree && this.$refs.areaTree.init()
    }
  }
}
</script>

<style lang="scss">
.consult-channel-list-filterbar .container .row .col.distict {
  max-width: 30%;
  span {
    display: inline-block;
    max-width: 85%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.consult-channel-list-filterbar {
  .van-sticky--fixed {
    width: 750px;
    left: 50%;
    margin-left: -375px;
    transition: transform 0.4s;
    background: #fff;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  }

  .van-overlay {
    width: 750px;
    left: 50%;
    margin-left: -375px;
  }
  &.slide-up {
    .van-sticky--fixed {
      // width: 750px;
      // position: fixed;
      // z-index: 11;
      transform: translate3d(0, -100%, 0);
    }
  }
  .popup {
    z-index: 1 !important;
    width: 750px;
    left: 50%;
    margin-left: -375px;
  }
}
.consult-channel-list-filterbar {
  width: 100%;
  position: relative;
  z-index: 2;
  // height: 80px;
  .container {
    width: 100%;
    /*height: 96px;*/
    position: relative;
    background: #fff;
    z-index: 1;
    .row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      padding: 0 32px;
      box-sizing: border-box;
      height: 80px;
      margin: 0 auto;
      line-height: 80px;
      .selected {
        color: #718aff;
      }
      .col {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 26px;
        span {
          // margin-left: 5px;
          vertical-align: middle;
        }
        .icon-node-website {
          font-size: 12 * 2 px;
          color: #21252d;
          display: inline-block;
          transform: scale(0.6);
        }
        .selected {
          color: #718aff;
        }
      }
    }
  }
  .filterbarpop-bg {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10;
  }
  .select-icon {
    display: inline-block;
    width: 14px;
    margin-left: 8px;
  }
}
</style>

<style lang="scss" scoped>
.sort-bar-wrap {
  font-size: 12px;
  padding: 0 0.42667rem;
  font-size: 12px;
  height: 50px;
  transition: transform 0.4s;
  ::v-deep ul {
    background: rgba(243, 244, 245, 1);
    border-radius: 8px;
    padding: 0;
    height: 50px;
    padding: 0 3px;
  }
  &.slide-up {
    // transform: translate3d(0, -100%, 0);
    display: none;
  }
}
::v-deep .van-sticky--fixed .sort-bar-wrap {
  padding-bottom: 20px;
}
::v-deep .lv2-tags .select-item.select-item-200 span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
